<template>
    <nav class="nav-wrap">
        <div class="header-logo-wrap">
            <router-link to="/madmin/center/main">
                <img v-if="centerLogo" :src="centerLogo" alt="로고사진" class="header-logo" />
                <img v-else src="/img/logo-wide.png" alt="로고사진" class="header-logo" />
            </router-link>
        </div>
        <div class="nav-top">
            <div class="photo-area">
                <img :src="profileImage" alt="유저 사진" class="nav-profile" @error="imageUrlAlt" />
                <!-- <a href="#" class="setting-btn"> -->
                <span class="blind">설정</span>
                <!-- </a> -->
            </div>
            <div class="info-area">
                <div class="nav-profile-name">{{ userName }}</div>
                <div class="nav-profile-position">{{ roleName }}</div>
                <a class="btn-logout" href="#" @click.prevent="onClickLogout">로그아웃</a>
            </div>
        </div>

        <!-- <div class="center-info">
            <button class="btn" @click="onClickCenter">{{ centerName }}</button>
        </div> -->
        <ul class="nav-items-wrap">
            <li @click="onClickCenter">
                <!-- <img src="" alt="" class="nav-item-icon"> -->

                <div class="menu-item">
                    <img src="/img/ic_home_off.png" alt="" class="nav-item-icon" />
                    <span class="menu-text">{{ centerName }}</span>
                    <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" />
                </div>
            </li>
            <li :class="{ on: menuList[0] === '홈' }">
                <router-link to="/madmin/center/main">
                    <div class="menu-item">
                        <img
                            :src="menuList[0] === '홈' ? '/img/ic_dashboard_on.png' : '/img/ic_dashboard_off.png'"
                            alt=""
                            class="nav-item-icon"
                        />
                        <span class="menu-text">대시보드</span>
                        <!-- <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" /> -->
                    </div>
                </router-link>
            </li>
            <li v-if="isAllowedMenu('SC')" :class="{ on: menuList[0] === '스케줄' }">
                <div class="menu-item menu-expand">
                    <img
                        :src="menuList[0] === '스케줄' ? '/img/ic_month_on.png' : '/img/ic_month_off.png'"
                        alt=""
                        class="nav-item-icon"
                    />
                    <span class="menu-text">스케쥴</span>
                    <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" />
                </div>
                <ul>
                    <li :class="{ on: menuList[1] === '일일스케줄' }" @click="changeState">
                        <router-link to="/madmin/schedule/day">일일스케줄</router-link>
                    </li>
                    <li :class="{ on: menuList[1] === '그룹 주간표' }" @click="changeState">
                        <router-link to="/madmin/schedule/group">그룹주간표</router-link>
                    </li>
                    <li :class="{ on: menuList[1] === '강사 주간표' }" @click="changeState">
                        <router-link to="/madmin/schedule/teacher">강사주간표</router-link>
                    </li>
                    <li :class="{ on: menuList[1] === '룸 스케줄표' }" @click="changeState">
                        <router-link to="/madmin/schedule/room">룸 스케줄표</router-link>
                    </li>
                </ul>
            </li>
            <li v-if="isAllowedMenu('MB')" :class="{ on: menuList[0] === '회원' }">
                <div class="menu-item menu-expand">
                    <img
                        :src="menuList[0] === '회원' ? '/img/ic_users_on.png' : '/img/ic_users_off.png'"
                        alt=""
                        class="nav-item-icon"
                    />
                    <span class="menu-text">회원</span>
                    <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" />
                </div>
                <ul>
                    <li v-if="isAllowed('MB', 1)" :class="{ on: menuList[1] === '회원관리' }" @click="changeState">
                        <router-link to="/madmin/member/list">회원관리</router-link>
                    </li>
                    <li :class="{ on: menuList[1] === '상담관리' }" @click="changeState">
                        <button
                            @click="
                                checkAllowedClick('MB', 3, () => {
                                    $router.push({ path: '/madmin/member/consult' });
                                })
                            "
                        >
                            상담관리
                        </button>
                    </li>
                    <li :class="{ on: menuList[1] === '기간연장내역' }" @click="changeState">
                        <router-link to="/madmin/member/period">기간연장내역</router-link>
                    </li>
                    <li v-if="isAllowed('MB', 6)" :class="{ on: menuList[1] === '락커내역' }" @click="changeState">
                        <router-link to="/madmin/member/locker">락커내역</router-link>
                    </li>
                </ul>
            </li>
            <li v-if="isAllowedMenu('LE')" :class="{ on: menuList[0] === '수업' }">
                <div class="menu-item menu-expand">
                    <img
                        :src="menuList[0] === '수업' ? '/img/ic_work_on.png' : '/img/ic_work_off.png'"
                        alt=""
                        class="nav-item-icon"
                    />
                    <span class="menu-text">수업</span>
                    <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" />
                </div>
                <ul>
                    <li :class="{ on: menuList[1] === '수업관리' }" @click="changeState">
                        <router-link to="/madmin/course/care">수업관리</router-link>
                        <!-- <ul>
                            <li :class="{ on: menuList[2] === '스케줄 예약' }">
                                <router-link to="/madmin/course/care/reserve">스케줄 예약</router-link>
                            </li>
                        </ul> -->
                    </li>
                    <li
                        v-if="isAllowed('SC', 3) || isAllowed('SC', 4)"
                        :class="{ on: menuList[1] === '수업 및 정산' }"
                        @click="changeState"
                    >
                        <router-link to="/madmin/course/account">수업 및 정산</router-link>
                    </li>

                    <li v-if="isAllowed('LE', 8)" :class="{ on: menuList[1] === '그룹레슨 관리' }" @click="changeState">
                        <router-link to="/madmin/course/lesson">그룹레슨 관리</router-link>
                    </li>
                </ul>
            </li>
            <li v-if="isAllowedMenu('SA') && includesEventCds('SA')" :class="{ on: menuList[0] === '매출' }">
                <div class="menu-item menu-expand">
                    <img
                        :src="menuList[0] === '매출' ? '/img/ic_calculate_on.png' : '/img/ic_calculate_off.png'"
                        alt=""
                        class="nav-item-icon"
                    />
                    <span class="menu-text">매출</span>
                    <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" />
                </div>
                <ul>
                    <li
                        v-if="isAllowed('SA', 1)"
                        :class="{ on: menuList[1] === '매출현황(상품)' }"
                        @click="changeState"
                    >
                        <router-link to="/madmin/sales/goods">매출현황(상품)</router-link>
                    </li>
                    <li
                        v-if="isAllowed('SA', 'FITPAY') && isAllowed('SA', 1) && isAllowed('SA', 2)"
                        :class="{ on: menuList[1] === '핏페이 매출' }"
                        @click="changeState"
                    >
                        <router-link to="/madmin/sales/fitpay/payment">핏페이 매출</router-link>
                    </li>
                    <li
                        v-if="isAllowed('SA', 2)"
                        :class="{ on: menuList[1] === '매출현황(전체)' }"
                        @click="changeState"
                    >
                        <router-link to="/madmin/sales/all">매출현황(전체)</router-link>
                    </li>
                    <li v-if="isAllowed('SA', 3)" :class="{ on: menuList[1] === '판매등록' }" @click="changeState">
                        <router-link to="/madmin/sales/sell">판매등록</router-link>
                    </li>
                    <li v-if="isAllowed('SA', 4)" :class="{ on: menuList[1] === '지출등록' }" @click="changeState">
                        <router-link to="/madmin/sales/expense">지출등록</router-link>
                    </li>
                    <li v-if="isAllowed('SA', 5)" :class="{ on: menuList[1] === '환불관리' }" @click="changeState">
                        <router-link to="/madmin/sales/refund">환불관리</router-link>
                    </li>
                </ul>
            </li>
            <li v-if="isAllowedMenu('PA') && includesEventCds('PA')" :class="{ on: menuList[0] === '급여' }">
                <div class="menu-item menu-expand">
                    <img
                        :src="menuList[0] === '급여' ? '/img/ic_wallet_on.png' : '/img/ic_wallet_off.png'"
                        alt=""
                        class="nav-item-icon"
                    />
                    <span class="menu-text">급여</span>
                    <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" />
                </div>
                <ul>
                    <li :class="{ on: menuList[1] === '월별정산' }" @click="changeState">
                        <router-link to="/madmin/salary/month">월별정산</router-link>
                    </li>
                    <li :class="{ on: menuList[1] === '성과보고서' }" @click="changeState">
                        <router-link to="/madmin/salary/result">성과보고서</router-link>
                    </li>
                    <li :class="{ on: menuList[1] === '이용권 정산내역' }" @click="changeState">
                        <router-link to="/madmin/salary/use">이용권 정산내역</router-link>
                    </li>
                </ul>
            </li>
            <li v-if="isAllowedMenu('ST') && includesEventCds('ST')" :class="{ on: menuList[0] === '통계' }">
                <div class="menu-item menu-expand">
                    <img
                        :src="menuList[0] === '통계' ? '/img/ic_graph_on.png' : '/img/ic_graph_off.png'"
                        alt=""
                        class="nav-item-icon"
                    />
                    <span class="menu-text">통계</span>
                    <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" />
                </div>
                <ul>
                    <li v-if="isAllowed('ST', 1)" :class="{ on: menuList[1] === '운영보고서' }" @click="changeState">
                        <router-link to="/madmin/stats/month">운영보고서</router-link>
                    </li>
                    <li v-if="isAllowed('ST', 2)" :class="{ on: menuList[1] === '매출통계' }" @click="changeState">
                        <router-link to="/madmin/stats/sale">매출통계</router-link>
                    </li>
                    <li v-if="isAllowed('ST', 3)" :class="{ on: menuList[1] === '직원통계' }" @click="changeState">
                        <router-link to="/madmin/stats/employee">직원통계</router-link>
                    </li>
                    <li v-if="isAllowed('ST', 4)" :class="{ on: menuList[1] === '회원이용통계' }" @click="changeState">
                        <router-link to="/madmin/stats/member">회원이용통계</router-link>
                    </li>
                </ul>
            </li>
            <li v-if="isAllowed('ME', 8)" :class="{ on: menuList[0] === '히스토리' }">
                <div class="menu-item menu-expand">
                    <img
                        :src="menuList[0] === '히스토리' ? '/img/ic_folder_on.png' : '/img/ic_folder_off.png'"
                        alt=""
                        class="nav-item-icon"
                    />
                    <span class="menu-text">히스토리</span>
                    <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" />
                </div>
                <ul>
                    <li :class="{ on: menuList[1] === '출석현황' }" @click="changeState">
                        <router-link to="/madmin/history/attendance">출석현황</router-link>
                    </li>
                    <li :class="{ on: menuList[1] === '예약취소내역' }" @click="changeState">
                        <router-link to="/madmin/history/reserve">예약취소내역</router-link>
                    </li>
                    <li :class="{ on: menuList[1] === '입장내역' }" @click="changeState">
                        <router-link to="/madmin/history/entrance">입장내역</router-link>
                    </li>
                    <li v-if="useClue" :class="{ on: menuList[1] === '출입기록' }" @click="changeState">
                        <router-link to="/madmin/history/access-log">출입기록</router-link>
                    </li>
                </ul>
            </li>
            <li v-if="includesEventCds('ME')" :class="{ on: menuList[0] === '메시지' }">
                <div class="menu-item menu-expand">
                    <img
                        :src="menuList[0] === '메시지' ? '/img/ic_conversation_on.png' : '/img/ic_conversation_off.png'"
                        alt=""
                        class="nav-item-icon"
                    />
                    <span class="menu-text">메시지</span>
                    <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" />
                </div>
                <ul>
                    <li v-if="isAllowed('ME', 1)" :class="{ on: menuList[1] === '메시지 발송' }" @click="changeState">
                        <router-link to="/madmin/message/send">메시지 발송</router-link>
                    </li>
                    <li v-if="isAllowed('ME', 2)" :class="{ on: menuList[1] === '발송내역' }" @click="changeState">
                        <router-link to="/madmin/message/history">발송내역</router-link>
                    </li>
                    <li
                        v-if="isAllowed('ME', 3)"
                        :class="{ on: menuList[1] === '메시지 내용설정' }"
                        @click="changeState"
                    >
                        <router-link to="/madmin/message/setting/auto">메시지 내용설정</router-link>
                    </li>
                    <li :class="{ on: menuList[1] === '충전내역 및 설정' }" @click="changeState">
                        <router-link to="/madmin/message/charge/call">발신번호 설정</router-link>
                    </li>
                    <li :class="{ on: menuList[1] === 'SMS 충전' }" @click="changeState">
                        <router-link to="/madmin/message/sms/charge">SMS 충전</router-link>
                    </li>
                </ul>
            </li>
            <li v-if="isAllowedMenu('BD')" :class="{ on: menuList[0] === '업무게시판' }">
                <div class="menu-item menu-expand">
                    <img
                        :src="menuList[0] === '업무게시판' ? '/img/ic_clipboard_on.png' : '/img/ic_clipboard_off.png'"
                        alt=""
                        class="nav-item-icon"
                    />
                    <span class="menu-text">업무게시판</span>
                    <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" />
                </div>
                <ul>
                    <li :class="{ on: menuList[1] === '업무전달' }">
                        <router-link to="/madmin/board/list" @click="changeState">업무전달</router-link>
                    </li>
                </ul>
            </li>
            <li :class="{ on: menuList[0] === '마이페이지' }">
                <div class="menu-item menu-expand">
                    <img
                        :src="menuList[0] === '마이페이지' ? '/img/ic_user_on.png' : '/img/ic_user_off.png'"
                        alt=""
                        class="nav-item-icon"
                    />
                    <span class="menu-text">마이페이지</span>
                    <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" />
                </div>
                <ul>
                    <li :class="{ on: menuList[1] === '담당회원확인' }" @click="changeState">
                        <router-link to="/madmin/mypage/list">담당회원확인</router-link>
                    </li>
                    <li :class="{ on: menuList[1] === '예약/취소 내역' }" @click="changeState">
                        <router-link to="/madmin/mypage/reserve">예약/취소 내역</router-link>
                    </li>
                    <li :class="{ on: menuList[1] === '개인정보설정' }" @click="changeState">
                        <router-link to="/madmin/mypage/info">개인정보설정</router-link>
                    </li>
                    <li :class="{ on: menuList[1] === '인사정보' }" @click="changeState">
                        <router-link to="/madmin/mypage/salary">인사정보</router-link>
                    </li>
                </ul>
            </li>
            <li v-if="isAllowed('CC', 1)" :class="{ on: menuList[0] === '센터설정' }">
                <div class="menu-item menu-expand">
                    <img
                        :src="menuList[0] === '센터설정' ? '/img/ic_settings_on.png' : '/img/ic_settings_off.png'"
                        alt=""
                        class="nav-item-icon"
                    />
                    <span class="menu-text">센터설정</span>
                    <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" />
                </div>
                <ul style="height: auto !important">
                    <li :class="{ on: menuList[1] === '센터관리' }" @click="changeState">
                        <router-link to="/madmin/setting/center/list">센터관리</router-link>
                    </li>
                    <li :class="{ on: menuList[1] === '상품관리' }" @click="changeState">
                        <router-link to="/madmin/setting/goods/use">상품관리</router-link>
                    </li>
                    <li :class="{ on: menuList[1] === '락커' }" @click="changeState">
                        <router-link to="/madmin/setting/locker">락커</router-link>
                    </li>
                    <li :class="{ on: menuList[1] === '마일리지' }" @click="changeState">
                        <router-link to="/madmin/setting/mileage">마일리지</router-link>
                    </li>
                    <li :class="{ on: menuList[1] === '예약시간 설정' }" @click="changeState">
                        <router-link to="/madmin/setting/reservation/time">예약시간 설정</router-link>
                    </li>
                    <li v-if="showElectronicContract" :class="{ on: menuList[1] === '전자계약' }" @click="changeState">
                        <router-link to="/madmin/setting/electronic/contract/manage">전자계약</router-link>
                    </li>
                    <li :class="{ on: menuList[1] === '권한구성' }" v-if="isAllowed('CC', 6)" @click="changeState">
                        <router-link to="/madmin/setting/author">권한구성</router-link>
                    </li>
                    <li :class="{ on: menuList[1] === '룸 관리' }" @click="changeState">
                        <router-link to="/madmin/setting/room">룸 관리</router-link>
                    </li>
                    <li :class="{ on: menuList[1] === '터치모니터' }" @click="changeState">
                        <router-link to="/madmin/setting/touch">터치모니터</router-link>
                    </li>
                    <li :class="{ on: menuList[1] === '키오스크' }" @click="changeState" v-if='kioskYn'>
                        <router-link to="/madmin/setting/kiosk">키오스크</router-link>
                    </li>
                </ul>
            </li>
            <li v-if="isAllowed('CC', 2)" :class="{ on: menuList[0] === '직원설정' }">
                <div class="menu-item menu-expand">
                    <img
                        :src="menuList[0] === '직원설정' ? '/img/ic_chat_on.png' : '/img/ic_chat_off.png'"
                        alt=""
                        class="nav-item-icon"
                    />
                    <span class="menu-text">직원설정</span>
                    <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" />
                </div>
                <ul>
                    <li :class="{ on: menuList[1] === '직원관리' }" @click="changeState">
                        <router-link to="/madmin/setting/employee/list">직원관리</router-link>
                    </li>
                    <!--
          <li :class="{'on': menuList[1] === '직원권한설정'}"><router-link to="/madmin/setting/employee/setup">직원권한설정</router-link></li>
          -->
                    <li :class="{ on: menuList[1] === '직원노출여부' }" @click="changeState">
                        <router-link to="/madmin/setting/employee/check">직원노출여부</router-link>
                    </li>
                    <li :class="{ on: menuList[1] === '팀 설정' }" @click="changeState">
                        <router-link to="/madmin/setting/employee/team">팀 설정</router-link>
                    </li>
                </ul>
            </li>
            <li v-if="includesEventCds('CC')" :class="{ on: menuList[0] === '회원설정' }">
                <div class="menu-item menu-expand">
                    <img
                        :src="menuList[0] === '회원설정' ? '/img/ic_edit_on.png' : '/img/ic_edit_off.png'"
                        alt=""
                        class="nav-item-icon"
                    />
                    <span class="menu-text">회원설정</span>
                    <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" />
                </div>
                <ul>
                    <li v-if="isAllowed('CC', 3)" :class="{ on: menuList[1] === '회원그룹설정' }" @click="changeState">
                        <router-link to="/madmin/setting/member/group">회원그룹설정</router-link>
                    </li>
                    <li v-if="isAllowed('CC', 4)" :class="{ on: menuList[1] === '회원공지사항' }" @click="changeState">
                        <router-link to="/madmin/setting/member/notice/list">회원공지사항</router-link>
                    </li>
                    <li v-if="isAllowed('CC', 5)" :class="{ on: menuList[1] === '회원팝업' }" @click="changeState">
                        <router-link to="/madmin/setting/member/pop/list">회원팝업</router-link>
                    </li>
                </ul>
            </li>
            <li v-if="isAllowed('ME', 4) && isInsteadOfAdmin" :class="{ on: menuList[0] === '엑셀 일괄업로드' }">
                <router-link to="/madmin/excel/member" @click="changeState">
                    <div class="menu-item">
                        <img
                            :src="menuList[0] === '엑셀 일괄업로드' ? '/img/ic_excel_on.png' : '/img/ic_excel_off.png'"
                            alt=""
                            class="nav-item-icon"
                        />
                        <span class="menu-text">엑셀 일괄업로드</span>
                        <!-- <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" /> -->
                    </div>
                </router-link>
            </li>
            <!-- <li :class="{'on': menuList[0] === '경리나라'}">
          <button class="blue">경리나라</button>
          <ul>
              <li :class="{'on': menuList[1] === '매출'}" @click="changeState"><router-link to="/madmin/account/sales/tax" >매출</router-link></li>
              <li :class="{'on': menuList[1] === '매입'}" @click="changeState"><router-link to="/madmin/account/purchase/tax" >매입</router-link></li>
              <li :class="{'on': menuList[1] === '금융'}" @click="changeState"><router-link to="/madmin/account/finance/bank" >금융</router-link></li>
          </ul>
      </li> -->
        </ul>
        <ul class="nav-items-wrap">
            <li :class="{ on: menuList[0] === '공지사항' }">
                <router-link to="/madmin/notice/list" @click="changeState">
                    <div class="menu-item">
                        <img
                            :src="
                                menuList[0] === '공지사항'
                                    ? '/img/ic_notification_on.png'
                                    : '/img/ic_notification_off.png'
                            "
                            alt=""
                            class="nav-item-icon"
                        />
                        <span class="menu-text">공지사항</span>
                        <!-- <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" /> -->
                    </div>
                </router-link>
            </li>
            <li :class="{ on: menuList[0] === '자주하는 질문' }">
                <router-link to="/madmin/question/list" @click="changeState">
                    <div class="menu-item">
                        <img
                            :src="menuList[0] === '자주하는 질문' ? '/img/ic_chat_on.png' : '/img/ic_chat_off.png'"
                            alt=""
                            class="nav-item-icon"
                        />
                        <span class="menu-text">자주하는 질문</span>
                        <!-- <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" /> -->
                    </div>
                </router-link>
            </li>
            <li :class="{ on: menuList[0] === '사용자 매뉴얼' }">
                <router-link to="/madmin/manual/list" @click="changeState">
                    <div class="menu-item">
                        <img
                            :src="menuList[0] === '사용자 매뉴얼' ? '/img/ic_book_on.png' : '/img/ic_book_off.png'"
                            alt=""
                            class="nav-item-icon"
                        />
                        <span class="menu-text">사용자 매뉴얼</span>
                        <!-- <img src="/img/icon/arrow_bottom.png" alt="" class="nav-item-arrow" /> -->
                    </div>
                </router-link>
            </li>
            <!--            <li>-->
            <!--                <router-link to='/madmin/qna/list' @click='changeState'>1:1 문의하기</router-link>-->
            <!--            </li>-->
        </ul>
        <div class="nav-bottom">
            <ul>
                <li v-for="(banner, index) in bannerList" :key="index">
                    <img :src="banner.url" style="width: 100%" @click="onClickBanner(banner.link)" />
                </li>
            </ul>
        </div>
        <div v-if="isStopPopup" class="stop-pop">
            <button class="close-btn" @click="isStopPopup = false"></button>
        </div>

        <modal name="centers" :adaptive="true" :width="500" height="auto">
            <div class="container">
                <div slot="top-right">
                    <button class="close" @click="$modal.hide('centers')"></button>
                </div>
                <div class="title">센터 변경</div>
                <button
                    class="center"
                    v-for="center in $store.state.auth.centers.filter((c) => c.centerId != centerId)"
                    @click="onSwitchCenter(center)"
                >
                    {{ center.centerName }}
                </button>
            </div>
        </modal>
    </nav>
</template>

<script>
import { mapState } from 'vuex';
import api from '@/assets/js/api';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import { Utils } from '@/assets/js/utils';
import jQuery from 'jquery';

import { EventBus } from '../main';

export default {
    name: 'careNavigation',
    mixins: [MixinAllowedMenu],
    props: {
        propsSample: {
            type: Number,
            default: 0,
            required: false,
            validator(value) {
                return value >= 0;
            },
        },
    },
    created() {
        EventBus.$on('refresh_menu', (param) => {
            this.showElectronicContract = !this.showElectronicContract;
        });
        EventBus.$on('refresh_menu2', (param) => {
            this.showElectronicContract = param.showElectronicContract;
        });
    },
    computed: {
        menuList() {
            return this.$route.meta.gnbMenu;
        },
        profileImage() {
            if (Utils.isEmpty(this.myProfileImage)) {
                // return 'http://fittoday-web-pub.s3-website-ap-northeast-1.amazonaws.com/img/temp/img_profile_admin%20user.png';
                return '/img/temp/img_profile_admin%20user.png';
            }

            return this.myProfileImage;
        },
        ...mapState({
            userName: (state) => state.auth.user.userName,
            centerId: (state) => state.auth.user.centerId,
            staffId: (state) => state.auth.user.uid,
            roleName: (state) => state.auth.user.rnm,
            isInsteadOfAdmin: (state) => state.auth.user.insteadAdmin,
            centerList: (state) => state.auth.centers,
        }),
    },
    data() {
        return {
            centerName: '',
            myProfileImage: '',
            centerLogo: '',
            kioskYn: false,
            useClue: false, // 센터 슈프리마(CLUe) 사용여부 — 출입기록 메뉴 게이트(fail-closed)
            // isUseSms: true,
            isStopPopup: false,
            isMove: false,
            bannerList: [],
            showElectronicContract: false,
        };
    },
    async mounted() {
        // this.menuList = this.$route.meta.gnbMenu;
        await this.fetchMenuInfo();
        await this.fetchUseSms();
        await this.changeState();
        await this.fetchCenterBanner();

        this.checkShowElectronicContract();

        /* 펼치기 */
        jQuery('.nav-items-wrap > li > .menu-expand').on('click', function slide() {
            jQuery('.nav-items-wrap > li > ul').not(jQuery(this)).stop().slideUp();
            jQuery(this).next('ul').stop().slideToggle();
        });
    },
    methods: {
        async checkShowElectronicContract() {
            this.showElectronicContract = await this.isAllowed('ME', 5);
        },
        onClickLogout() {
            // LOGOUT 변이 실행 후 리다이렉트
            // this.$store.dispatch('auth/logout').then(() => this.$router.push('/login'));
            const url = parseInt(this.centerId, 10) === 0 ? '/care/login' : '/login';
            this.$store.dispatch('auth/logout');
            this.$router.push(url);
        },
        async fetchMenuInfo() {
            try {
                Promise.allSettled([this.getMyInfo(), this.getCenterInfo()]).then((res) => {
                    const staff = res[0].value.data;
                    const center = res[1].value.data;

                    this.myProfileImage = staff.imageUrl;
                    this.centerName = center.centerName;
                    this.centerLogo = center.logoUrl;
                    this.kioskYn = center.kioskYn;
                    this.useClue = center.useClue === true;
                });
            } catch (e) {
                console.log(e);
            }
        },
        async fetchUseSms() {
            try {
                const { data } = await this.getUseSms();
                // this.isUseSms = data;
            } catch (e) {
                console.log(e);
            }
        },
        getMyInfo() {
            return api.get(`/admin/api/center/${this.centerId}/staff/${this.staffId}`);
        },
        getCenterInfo() {
            return api.get(`/admin/api/center/${this.centerId}`);
        },
        getUseSms() {
            return api.get('/admin/api/center/ftcontract/sms');
        },
        // staff image 없을 경우 default image 표시
        imageUrlAlt(event) {
            event.target.src = '/img/temp/img_profile_admin%20user.png';
        },
        async changeState() {
            try {
                const { data } = await api.get('/admin/api/ft/contract/program/list', {
                    params: {
                        page: 1,
                        limit: 1,
                        contractStatus: 'O',
                        centerId: this.centerId,
                    },
                });

                this.isStopPopup = data.items.length === 0;
            } catch (error) {
                console.error(error);
            }
        },
        async fetchCenterBanner() {
            try {
                const { data } = await this.getCenterBanner();
                this.bannerList = [];
                for (let i = 0; i < 3; i += 1) {
                    if (data[`adminWeb${i + 1}Link`] && data[`adminWeb${i + 1}Url`]) {
                        this.bannerList.push({
                            link: data[`adminWeb${i + 1}Link`],
                            url: data[`adminWeb${i + 1}Url`],
                        });
                    }
                }
            } catch (error) {
                console.error(error);
            }
        },
        getCenterBanner() {
            // 스웨거 검색: 센터 배너 조회
            return api.get('/admin/api/centerBanner/0');
        },
        onClickBanner(link) {
            window.open(link);
        },
        includesEventCds(menu) {
            // @TODO: 테스트를 위해 메뉴 권한 설정은 막아둠
            // 통합테스트 시 오픈
            // return true;
            // /////////////

            const eventCds = this.allowedMenuEvent.eventCds;

            if (eventCds) {
                if (menu === 'ME') {
                    // 메시지 메뉴에 대한 숨김 처리 여부
                    return (
                        eventCds.includes('ME_EVENT_001') ||
                        eventCds.includes('ME_EVENT_002') ||
                        eventCds.includes('ME_EVENT_003')
                    );
                } else if (menu === 'CC') {
                    // 회원설정 메뉴에 대한 숨김 처리 여부
                    return (
                        eventCds.includes('CC_EVENT_003') ||
                        eventCds.includes('CC_EVENT_004') ||
                        eventCds.includes('CC_EVENT_005')
                    );
                } else if (menu === 'PA') {
                    // 급여 메뉴에 대한 숨김 처리 여부
                    return (
                        eventCds.includes('PA_EVENT_001') ||
                        eventCds.includes('PA_EVENT_002') ||
                        eventCds.includes('PA_EVENT_003')
                    );
                }

                for (const eventCd of eventCds) {
                    if (eventCd.split('_')[0] === menu) return true;
                }
            }

            return false;
        },

        onClickCenter() {
            if (!this.centerList || this.centerList.length < 2) return;

            this.$modal.show('centers');
        },

        onSwitchCenter(center) {
            this.$modal.hide('centers');

            if (this.centerId == center.centerId) return;

            this.$store.dispatch('auth/switchCenter', center.centerId).then(() => {
                this.$router.push({ name: 'CenterMain' });
            });
        },
    },
    watch: {
        centerId(val) {
            this.fetchMenuInfo();
            this.fetchUseSms();
            this.changeState();
            this.fetchCenterBanner();
        },
    },
};
</script>

<style lang="scss" scoped>
.vm--modal {
    .container {
        padding: 16px;
    }

    .title {
        padding-top: 20px;
        padding-bottom: 10px;
        text-align: center;
        font-size: 20px;
        color: #00c7e5;
    }

    .close {
        float: right;
        width: 20px;
        height: 20px;
        background: url(/img/icons/layerpop_square_close_btn.jpg) no-repeat 0 0;
        border: none;
    }

    .center {
        display: block;
        width: 100%;
        height: 56px;
        margin-top: 16px;
        border-radius: 0;
        border: 1px solid #e1e1e1;
        background: #f1f5f7;
        font-size: 16px;
        text-align: center;
        color: #7e7777;
    }
}
</style>
